module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-3.f81c938f.mp3";